import { render } from "./FormInput.vue?vue&type=template&id=3b397ca6&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=3b397ca6&lang=css"
import "./FormInput.vue?vue&type=style&index=1&id=3b397ca6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b397ca6"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField});
